import { Validations } from './Constants';
import { checkValidUrl } from './utils';

export const validateBasicDetails = (values:InitialStateTalentsEditForm,
  socialLinks:SocialLinkItem[]):
  Partial<InitialStateTalentsEditForm> => {
  const errors: Partial<InitialStateTalentsEditForm> = {};
  const links = [
    ...socialLinks.map((socialLink:SocialLinkItem) => {
      return {
        id: socialLink.id,
        value: socialLink.url,
      };
    })];

  if (links) {
    links.forEach(({ id, value }) => {
      if (!value) {
        if (errors.socialLinks) {
          errors.socialLinks = [
            ...errors.socialLinks,
            {
              id,
              value: Validations.SocialLink.Required.text,
            },
          ];
        } else {
          errors.socialLinks = [
            {
              id,
              value: Validations.SocialLink.Required.text,
            },
          ];
        }
      } else if (!checkValidUrl(value)) {
        if (errors.socialLinks) {
          errors.socialLinks = [
            ...errors.socialLinks,
            {
              id,
              value: Validations.SocialLink.Invalid.text,
            },
          ];
        } else {
          errors.socialLinks = [
            {
              id,
              value: Validations.SocialLink.Invalid.text,
            },
          ];
        }
      }
    });
  }

  if (!values.firstname) {
    errors.firstname =  Validations.FirstName.Required.text;
  }

  if (!values.lastname) {
    errors.lastname =  Validations.LastName.Required.text;
  }

  if (values.attributes) {
    values.attributes.forEach(({ id, name, description }) => {
      if (!name || !description) {
        const attributes = {
          id,
          name: !name ? Validations.Attributes.Name.Required.text : '',
          description: !description ? Validations.Attributes.Description.Required.text : '',
        };
        if (errors.attributes) {
          errors.attributes = [
            ...errors.attributes,
            { ...attributes },
          ];
        } else {
          errors.attributes = [attributes];
        }
      }
    });
  }

  if (values.skills) {
    values.skills.forEach(({ id, name, level }) => {
      if (!name || !level) {
        const skillError =  {
          id,
          name: !name ? Validations.Skills.Name.Required.text : '',
          level: !level ? Validations.Skills.Level.Required.text : level,
        };

        if (errors.skills) {
          errors.skills = [
            ...errors.skills,
            skillError,
          ];
        } else {
          errors.skills = [{ ...skillError }];
        }
      }
    });
  }

  if (!values.country) {
    errors.country =  Validations.Country.Required.text;
  }

  return errors;
};
